import { useWeb3React } from '@web3-react/core'
import history from 'assets/svg/history.svg'
import clsx from 'clsx'
import { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { BrigeForm } from './bridge'
import { BSC_OFT, WORLDCHAIN_OFT, ZKSYNC_OFT } from './constant'

export function Header() {
  const { account } = useWeb3React()
  const { control } = useFormContext<BrigeForm>()

  const fromChainId = useWatch({ control, name: 'from.chainId' })
  const toChainId = useWatch({ control, name: 'to.chainId' })
  const toLink = useMemo(() => {
    if (fromChainId === ZKSYNC_OFT.chainId && toChainId === BSC_OFT.chainId) {
      return `https://ccip.chain.link/address/${account}`
    }
    if (fromChainId === ZKSYNC_OFT.chainId && toChainId === WORLDCHAIN_OFT.chainId) {
      return `https://ccip.chain.link/address/${account}`
    }
    if (fromChainId === ZKSYNC_OFT.chainId) {
      return `https://explorer.zksync.io/address/${account}`
    }

    return `https://berascan.com/address/${account}`
  }, [fromChainId, toChainId, account])
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-white text-2xl font-medium">Bridge</h2>

      <Link
        to={toLink}
        target="_blank"
        className={clsx('flex justify-center items-center gap-1 px-2 py-1 bg-[#1f1f1f] rounded-full', {
          'opacity-0 pointer-events-none invisible': !account,
        })}
      >
        <div className="w-5 h-5 relative">
          <img src={history} alt="history" width={20} height={20} loading="lazy" className="w-full h-full" />
        </div>

        <p className="text-white text-sm">History</p>
      </Link>
    </div>
  )
}
